import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

import Giris from './pages/Giris/Index'
import Panel from './pages/Panel/Index'
import SayfaYok from './comp/SayfaYok'

// MUHASEBE

import MuhasebeIndex from './pages/Muhasebe/Index'
import MuhasebeCari from './pages/Muhasebe/Cari'
import MuhasebeCariIndex from './pages/Muhasebe/Cari/Index'
import MuhasebeCariDetay from './pages/Muhasebe/Cari/Detay'
import MuhasebeHizmet from './pages/Muhasebe/Hizmet'
import MuhasebeGrup from './pages/Muhasebe/Grup'

// RAPORLAMA

import RaporlamaIndex from './pages/Raporlama/Index'
import zRaporu from "./pages/Raporlama/zRaporu";
import KasaRaporu from "./pages/Raporlama/KasaRaporu";
import AlacakRaporu from "./pages/Raporlama/AlacakRaporu";
import BorcRaporu from "./pages/Raporlama/BorcRaporu";

Vue.use(VueRouter);

export const router = new VueRouter({
    routes: [
        {
            path: "/giris",
            component: Giris,
            beforeEnter(to, from, next) {
                if (store.getters.isOturum) {
                    next("/panel");
                } else {
                    next();

                }
            }
        },
        {
            path: "/",
            component: Panel,
        },
        {
            path: "/panel",
            component: Panel,
        },
        {
            path: "/muhasebe",
            component: MuhasebeIndex,
            children: [
                {path: "", component: MuhasebeIndex},
                {
                    path: "cari", component: MuhasebeCari,
                    children: [
                        {path:"",component:MuhasebeCariIndex},
                        {path:":Cari_id",component:MuhasebeCariDetay, props: true},
                    ]
                },
                {path: "grup", component: MuhasebeGrup},
                {path: "hizmet", component: MuhasebeHizmet},
            ],
        },
        {
            path: "/raporlama",
            component: RaporlamaIndex,
            children: [
                {path: "", component: RaporlamaIndex},
                {path: "zraporu", component: zRaporu},
                {path: "kasa", component: KasaRaporu},
                {path: "alacak", component: AlacakRaporu},
                {path: "borc", component: BorcRaporu},
            ],
        },
        {
            path: "*",
            component: SayfaYok,
        }

    ],
    mode: "history"
});



// WEBPACK FOOTER //
// ./src/router.js